import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { userTokenRefresh } from "../store/user/actions";
import { withRouter } from "react-router-dom";

const REFRESH_TIME = 280000;

class TokenRefreshComponent extends Component {

  state = {};

  componentDidMount() {
    if (this.props.isLogin) {
      this.setTimeRefresh();
    }
  }

  setTimeRefresh = () => {
    clearInterval(this.interval)
    this.interval = setInterval(() => {
      this.props.userTokenRefresh(this.props.history);
    }, REFRESH_TIME);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isLogin !== prevProps.isLogin) {
      if (this.props.isLogin) {
        this.setTimeRefresh();
      } else {
        clearInterval(this.interval);
      }
    }
  }

  render() {
    return (
      <>
      </>
    );
  }
}

TokenRefreshComponent.propTypes = {
  isLogin: PropTypes.bool,
  userTokenRefresh: PropTypes.func,
  history: PropTypes.object
};

const mapStateToProps = state => {
  return {
    isLogin: state.User.isLogin
  };
};

export default connect(mapStateToProps, { userTokenRefresh })(withRouter(TokenRefreshComponent));
